module.exports = __webpack_public_path__ + "img/blue_whatsapp.24db96ab.svg";